<template>
  <v-dialog
    v-model="show"
    width="90vw"
    persistent
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <template
      v-for="(_, scopedSlotName) in $scopedSlots"
      #[scopedSlotName]="slotData"
    >
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>
    <template v-for="(_, slotName) in $slots" #[slotName]>
      <slot :name="slotName" />
    </template>
    <v-card flat :loading="isLoading" :min-width="minWidth">
      <v-card-title>
        <div>{{ isEdit ? 'Edit Holiday' : 'Create Holiday' }}</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text style="min-height: 200px">
        <v-form ref="form" :disabled="readonly || isLoading">
          <div class="label mb-2">Name</div>
          <v-text-field
            v-model="form.name"
            :error="form.errors.name"
            :error-messages="form.errors.name"
            :rules="[validationRules.required]"
            solo
            flat
            outlined
            dense
            placeholder="Holiday name"
          />
          <div class="label mb-2">Name (Chinese)</div>
          <v-text-field
            v-model="form.name_cn"
            solo
            flat
            outlined
            dense
            placeholder="Holiday name (chinese)"
          />
          <div class="label mb-2">Holiday Date</div>
          <v-menu
            ref="dateMenu"
            v-model="dateMenu"
            :return-value.sync="dates"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                :value="dateRangeText"
                :rules="[validationRules.required]"
                placeholder="Select holiday date"
                prepend-icon="mdi-calendar"
                solo
                flat
                outlined
                dense
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="dates" range scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="dateMenu = false">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="$refs.dateMenu.save(dates)">
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
          <div class="label mb-2">Status</div>
          <v-select
            v-model="form.status"
            :items="statusOptions"
            :rules="[validationRules.required]"
            :error="form.errors.status"
            :error-messages="form.errors.status"
            solo
            flat
            outlined
            dense
            placeholder="Select holiday status"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-container fluid>
          <v-row justify="end">
            <v-col md="3" cols="12">
              <v-btn block depressed outlined @click="cancel">Cancel</v-btn>
            </v-col>
            <v-col md="3" cols="12">
              <v-btn
                block
                depressed
                color="primary"
                :disabled="readonly || isLoading"
                @click="submit"
              >
                Save Changes
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import constant from '@/constant'
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    classroomId: {
      type: Number,
      default: null,
      required: false,
    },
    item: {
      type: Object,
      default: () => null,
      required: false,
    },
    minWidth: {
      type: [String, Number],
      default: null,
      required: false,
    },
    readonly: {
      type: Boolean,
      default: false,
      required: false,
    },
    submitApi: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dateMenu: false,
      form: this.$inertia.form({
        name: null,
        name_cn: null,
        start_date: null,
        end_date: null,
        status: null,
        classroom_ids: [],
        is_global: false,
        is_annual: false,
      }),
      dates: [],
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'holiday/isDetailLoading',
      holiday: 'holiday/detail',
    }),
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    isEdit() {
      return this.item !== null && this.item.id !== null
    },
    dateRangeText() {
      return this.dates.join(' - ')
    },
    statusOptions() {
      return constant.holidayStatusOptions
    },
  },
  created() {
    this.init()
  },
  methods: {
    ...mapActions({
      createHoliday: 'holiday/create',
      updateHoliday: 'holiday/update',
      handleError: 'handleError',
    }),
    init() {
      if (this.isEdit) {
        _.merge(this.form, this.item)
        this.dates = [this.form.start_date, this.form.end_date]
        if (this.item.classrooms) {
          this.form.classroom_ids = this.item.classrooms.map((e) => e.id)
        }
      } else if (this.classroomId) {
        this.form.classroom_ids.push(this.classroomId)
      }
    },
    cancel() {
      this.show = false
    },
    async submit() {
      if (this.$refs.form.validate()) {
        if (this.dates.length === 2) {
          this.form.start_date = this.dates[0]
          this.form.end_date = this.dates[1]
        }
        const req = JSON.parse(JSON.stringify(this.form))
        let err = null
        if (this.submitApi) {
          err = this.isEdit
            ? await this.updateHoliday(req)
            : await this.createHoliday(req)
        }
        if (!err) {
          const resp = JSON.parse(JSON.stringify(this.holiday))
          this.$emit('submit', resp)
          this.$emit('update:item', resp)
          this.form.reset()
          this.$refs.form.reset()
        }
      }
    },
  },
}
</script>
